module.exports = __webpack_public_path__ + "img/install-chuti.222693f0.jpg";